import { makeActionCreator } from '../util/state'

import {
  APPEND_TEMPLATE_FIELD_TO_LIST,
  EDIT_TEMPLATE_FIELD_TYPE,
  EDIT_TEMPLATE_NAME,
  FETCH_CHANGE_ACTIVE_TEMPLATE_ID,
  FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS,
  FETCH_CREATE_TEMPLATE,
  FETCH_CREATE_TEMPLATE_SUCCESS,
  FETCH_DELETE_TEMPLATE,
  FETCH_DELETE_TEMPLATE_SUCCESS,
  FETCH_SAVE_TEMPLATE,
  FETCH_SAVE_TEMPLATE_SUCCESS,
  FETCH_TEMPLATES,
  FETCH_TEMPLATES_SUCCESS,
  REMOVE_TEMPLATE_FIELD_FROM_LIST,
  SET_TEMPLATE_LIST_SHOW_STATUS,
  UPDATE_TEMPLATE_FIELDS
} from '../constants/ActionTypes'

export const fetchTemplates = makeActionCreator(FETCH_TEMPLATES)
export const fetchTemplatesSuccess = makeActionCreator(FETCH_TEMPLATES_SUCCESS, 'byId', 'allIDs', 'activeId')

export const fetchChangeActiveTemplateId = makeActionCreator(FETCH_CHANGE_ACTIVE_TEMPLATE_ID, 'id')
export const fetchChangeActiveTemplateIdSuccess = makeActionCreator(FETCH_CHANGE_ACTIVE_TEMPLATE_ID_SUCCESS, 'id', 'message')

export const fetchCreateTemplate = makeActionCreator(FETCH_CREATE_TEMPLATE, 'name')
export const fetchCreateTemplateSuccess = makeActionCreator(FETCH_CREATE_TEMPLATE_SUCCESS, 'id', 'entry', 'activeId', 'message')

export const editTemplateName = makeActionCreator(EDIT_TEMPLATE_NAME, 'id', 'name')

export const updateTemplateFields = makeActionCreator(UPDATE_TEMPLATE_FIELDS, 'id', 'type', 'fields')

export const appendTemplateFieldToList = makeActionCreator(APPEND_TEMPLATE_FIELD_TO_LIST, 'id', 'type', 'index')
export const removeTemplateFiledFromList = makeActionCreator(REMOVE_TEMPLATE_FIELD_FROM_LIST, 'id', 'type', 'index')

export const editFieldType = makeActionCreator(EDIT_TEMPLATE_FIELD_TYPE, 'id', 'type', 'index', 'fieldType')

export const setListShowStatus = makeActionCreator(SET_TEMPLATE_LIST_SHOW_STATUS, 'id', 'type', 'showStatus')

export const fetchSaveTemplate = makeActionCreator(FETCH_SAVE_TEMPLATE, 'id')
export const fetchSaveTemplateSuccess = makeActionCreator(FETCH_SAVE_TEMPLATE_SUCCESS, 'id', 'message')

export const fetchDeleteTemplate = makeActionCreator(FETCH_DELETE_TEMPLATE, 'id')
export const fetchDeleteTemplateSuccess = makeActionCreator(FETCH_DELETE_TEMPLATE_SUCCESS, 'id', 'activeId', 'message')



// WEBPACK FOOTER //
// ./actions/Template.js